import { formatUserFacingError } from '@/lib/errors'
import { useCallback, useEffect, useState } from 'react'
import { adminProductionsService } from '../services/adminProductions.service'
import type { ProductionDocument } from '@/types'

type Production = ProductionDocument & { id: string }

export function useProductions() {
  const [productions, setProductions] = useState<Production[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const [tick, setTick] = useState(0)

  const refresh = useCallback(() => setTick((t) => t + 1), [])

  useEffect(() => {
    setLoading(true)
    setError(null)
    adminProductionsService
      .getAll()
      .then(setProductions)
      .catch((err: unknown) =>
        setError(formatUserFacingError(err, 'Failed to load productions.'))
      )
      .finally(() => setLoading(false))
  }, [tick])

  return { productions, loading, error, refresh }
}
